/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import2 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import3 from '../../orchestration/page';
import * as import4 from '../../orchestration/navigation.service';
import * as import5 from '../receipt/receipt.component.ngfactory';
import * as import6 from '../receipt/receipt.component';
import * as import7 from './sale-receipt-page.component';
import * as import8 from '../../orchestration/navigation-params';
const styles_SaleReceiptPageComponent:any[] = ([] as any[]);
export const RenderType_SaleReceiptPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_SaleReceiptPageComponent,
  data: {}
}
);
export function View_SaleReceiptPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import1.View_ModalPageLayoutComponent_0,import1.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import2.ModalPageLayoutComponent,[
      import3.Page,
      import4.NavigationService
    ]
    ,(null as any),(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import3.PageLayout,(null as any),[import2.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),4,1,'woa-receipt',([] as any[]),(null as any),(null as any),(null as any),import5.View_ReceiptComponent_0,import5.RenderType_ReceiptComponent)),
      import0.ɵdid(49152,(null as any),0,import6.ReceiptComponent,([] as any[]),{receiptXml: [
        0,
        'receiptXml'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import7.SaleReceiptPageComponent = v.component;
    ck(v,2,0);
    const currVal_0:any = co.sale.saleReceipt;
    ck(v,8,0,currVal_0);
  },(null as any));
}
function View_SaleReceiptPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-sale-receipt-page',([] as any[]),(null as any),(null as any),(null as any),View_SaleReceiptPageComponent_0,RenderType_SaleReceiptPageComponent)),
    import0.ɵdid(49152,(null as any),0,import7.SaleReceiptPageComponent,[import8.NavigationParams],(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import3.Page,(null as any),[import7.SaleReceiptPageComponent])
  ]
  ,(null as any),(null as any));
}
export const SaleReceiptPageComponentNgFactory:import0.ComponentFactory<import7.SaleReceiptPageComponent> = import0.ɵccf('woa-sale-receipt-page',import7.SaleReceiptPageComponent,View_SaleReceiptPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvY3VzdG9tZXItaW5mby9zYWxlLXJlY2VpcHQtcGFnZS9zYWxlLXJlY2VpcHQtcGFnZS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9jdXN0b21lci1pbmZvL3NhbGUtcmVjZWlwdC1wYWdlL3NhbGUtcmVjZWlwdC1wYWdlLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvY3VzdG9tZXItaW5mby9zYWxlLXJlY2VpcHQtcGFnZS9zYWxlLXJlY2VpcHQtcGFnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvY3VzdG9tZXItaW5mby9zYWxlLXJlY2VpcHQtcGFnZS9zYWxlLXJlY2VpcHQtcGFnZS5jb21wb25lbnQudHMuU2FsZVJlY2VpcHRQYWdlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHdvYS1tb2RhbC1wYWdlLWxheW91dD5cbiAgICA8d29hLXJlY2VpcHQgW3JlY2VpcHRYbWxdPVwic2FsZS5zYWxlUmVjZWlwdFwiPjwvd29hLXJlY2VpcHQ+XG48L3dvYS1tb2RhbC1wYWdlLWxheW91dD5cbiIsIjx3b2Etc2FsZS1yZWNlaXB0LXBhZ2U+PC93b2Etc2FsZS1yZWNlaXB0LXBhZ2U+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lDQUE7Z0JBQUE7OztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF1QjtJQUNuQjtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTJEO0lBQ3ZDOzs7O0lBRnhCO0lBQ2lCO0lBQWIsU0FBYSxTQUFiOzs7OztJQ0RKO2dCQUFBO2dCQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/app/customer-info/sale-receipt-page/sale-receipt-page.component.ngfactory.ts